import React, { useState, useRef } from "react";
import CaseListTable from "../components/all-case-list/case-list-table/CaseListTable";
import AllDocumentsList from "../components/all-case-list/case-table/AllDocumentsList";
import Navbar from "../components/common/Navbar";
import DocumentsPageHeader from "../components/common/DocumentsPageHeader";
import baseUrl from "../config/baseUrl";
import "../styles/Documents.css";
import { TabName } from "../utils/setTabName";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

/*** Main component for listing all the unassigned documents & for showing all the unassinged documents inside the folder based on date ***/
const UnassignedCaseList = () => {
  const tableRef = useRef(null);

  // Same single-view layout as Incoming Emails/Faxes/Scanned Files (replaces
  // the old array-of-tabs model): null shows the main list, a row object
  // shows that folder's documents (same data the list used to open as a tab).
  const [selectedGroup, setSelectedGroup] = useState(null);
  // Set while a document/PDF is open (reported by CaseListTable /
  // AllDocumentsList) so the page header can be hidden.
  const [openDocumentTitle, setOpenDocumentTitle] = useState(null);

  const addDocumentTab = (document) => {
    setSelectedGroup(document);
    setOpenDocumentTitle(null);
  };

  const backToList = () => {
    setSelectedGroup(null);
    setOpenDocumentTitle(null);
  };

  return (
    <div className="document-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div
        className="document-content documents-zoom-scroll-scope"
        ref={tableRef}
        style={{
          scrollBehavior: "smooth",
          scrollTimingFunction: "ease-in-out",
        }}
      >
        <DocumentsPageHeader
          showBreadcrumb={!!selectedGroup}
          showHeader={!selectedGroup && !openDocumentTitle}
          breadcrumbs={[
            { label: "All Documents" },
            {
              label: "All Unassigned",
              onClick: selectedGroup ? backToList : undefined,
            },
            ...(selectedGroup ? [{ label: TabName(selectedGroup) }] : []),
          ]}
          icon={InboxOutlinedIcon}
          title="All Unassigned"
          description="Documents waiting to be assigned"
          headerSpacingClass="py-3"
        />
        <div className="tab-content">
          {selectedGroup ? (
            <AllDocumentsList
              caseList={selectedGroup.document_source_type}
              sourceDetails={selectedGroup.document_source_details}
              createdAt={selectedGroup.created_at}
              categoryName={selectedGroup.category}
              folderName={selectedGroup.uncategorized_from_name}
              assigned="FALSE"
              assigned_user_id=""
              onOpenDocumentChange={setOpenDocumentTitle}
              mainCaseList="all-unassigned"
            />
          ) : (
            <CaseListTable
              tableRef={tableRef}
              addDocumentTab={addDocumentTab}
              apiLink={`${baseUrl}/api/get-unassigned`}
              admin="1"
              caseList="all-unassigned"
              categoryName={document.category}
              assignUserFilter={false}
              folderName={document.uncategorized_from_name}
              onOpenDocumentChange={setOpenDocumentTitle}
              assignPage={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UnassignedCaseList;
